import { Pipe, PipeTransform } from '@angular/core';
import { Weekday } from '../../models';

@Pipe({
  name: 'stationHours',
  standalone: true,
  pure: true,
})
export class StationHoursPipe implements PipeTransform {
  transform(weekDay: Weekday): string {
    if (weekDay.Open) {
      return `${this.getHour(weekDay.OpenHour)}:${this.formatTimeString(weekDay.OpenMinute)} ${this.getMeridian(weekDay.OpenHour)} - ${this.getHour(weekDay.CloseHour)}:${this.formatTimeString(weekDay.CloseMinute)} ${this.getMeridian(weekDay.CloseHour)}`;
    } else {
      return 'Closed';
    }
  }

  getHour(hour: number) {
    if (hour > 12) {
      return `${hour - 12}`;
    }
    return `${hour}`;
  }

  formatTimeString(number: number) {
    if (number < 10) {
      return `0${number}`;
    }
    return `${number}`;
  }

  getMeridian(hour: number) {
    if (hour > 11) {
      return 'PM';
    }
    return 'AM';
  }
}
